// extracted by mini-css-extract-plugin
export default {"module":"Module_module__2LBmk","module-search":"Module_module-search__TYRGs"};